import React, { useEffect, useState } from "react";
import Slider from "../components/sidebar";
import { useNavigate } from "react-router-dom";
import { fetcsetting, updatesetting } from "../services/service";
import ErrorModal from "../components/error";
import SuccessModal from "../components/sucessmodel";
import { Settings, ToggleRight, ToggleLeft, Save, Palette, Key, MessageCircle, Phone, DollarSign, Link as LinkIcon } from "lucide-react";

const Setting = () => {
  const [adminId, setAdminId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [isSuccessVisible, setIsSuccessVisible] = useState(false);
  const [formData, setFormData] = useState({
    Id: "",
    btnSubCategory: true,
    btnDelivery: true,
    btnLocation: true,
    btnSubscription: true,
    btnRazorpay: true,
    COD: true,
    btnWallet: true,
    btnCoupon: true,
    txtPaymentId: "",
    txtUrl: "",
    basecolorCode: "",
    shadowcolorCode: "",
    whitecolorCode: "",
    lightblackcolorCode: "",
    colorCode: "",
    Firebasetext: "",
    WhatsAppUrl: "",
    OwnerMobileNo: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    const adminUserId = JSON.parse(localStorage.getItem("adminuserid"));
    if (!adminUserId) {
      alert("Session Closed. Please Login Again!");
      setTimeout(() => {
        navigate("/");
      }, 2000);
    } else {
      setAdminId(Number(adminUserId));
    }
  }, [navigate]);

  useEffect(() => {
    if (adminId) {
      fetchOfferData();
    }
  }, [adminId]);

  const fetchOfferData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetcsetting(adminId);
      const data = response?.data[0];

      if (data) {
        setFormData({
          ...formData,
          Id: data.Id || "",
          btnSubCategory: data.SubCategoryStatus === 1,
          btnDelivery: data.DeliveryStatus === 1,
          btnLocation: data.LocationStatus === 1,
          btnSubscription: data.SubscriptionStatus === 1 || false,
          btnRazorpay: !!data.PaymentId,
          COD: data.COD === 1,
          btnWallet: data.WalletStatus === 1 || false,
          btnCoupon: data.CouponStatus === 1 || false,
          txtPaymentId: data.PaymentId || "",
          txtUrl: data.MinOrderAmt || "",
          basecolorCode: data.basecolorCode || "",
          colorCode: data.colorCode || "",
          lightblackcolorCode: data.lightblackcolorCode || "",
          shadowcolorCode: data.shadowcolorCode || "",
          whitecolorCode: data.whitecolorCode || "",
          Firebasetext: data.FireBaseId || "",
          WhatsAppUrl: data.WhatsAppUrl || "",
          OwnerMobileNo: data.OwnerMobileNo || "",
        });
        localStorage.setItem("AdminSetting", JSON.stringify(data));
      } else {
        setError("No data available.");
      }
    } catch (err) {
      setError("Failed to fetch data: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [id]: type === "checkbox" ? checked : value,
    });
  };

  const handleToggle = (field) => {
    setFormData({
      ...formData,
      [field]: !formData[field],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    const objlist = {
      Id: formData.Id,
      CompanyRefId: adminId,
      SubCategoryStatus: formData.btnSubCategory ? 1 : 0,
      COD: formData.COD ? 1 : 0,
      DeliveryStatus: formData.btnDelivery ? 1 : 0,
      LocationStatus: formData.btnLocation ? 1 : 0,
      WalletStatus: formData.btnWallet ? 1 : 0,
      CouponStatus: formData.btnCoupon ? 1 : 0,
      SubscriptionStatus: formData.btnSubscription ? 1 : 0,
      PaymentId: formData.txtPaymentId,
      MinOrderAmt: formData.txtUrl,
      FireBaseId: formData.Firebasetext,
      basecolorCode: formData.basecolorCode,
      shadowcolorCode: formData.shadowcolorCode,
      whitecolorCode: formData.whitecolorCode,
      lightblackcolorCode: formData.lightblackcolorCode,
      colorCode: formData.colorCode,
      WhatsAppUrl: formData.WhatsAppUrl,
      OwnerMobileNo: formData.OwnerMobileNo,
    };
    console.log(objlist);
    try {
      const success = await updatesetting(objlist);

      if (success) {
        setSuccessMessage("Settings updated successfully!");
        setIsSuccessVisible(true);
        setTimeout(() => {
          navigate("/index");
        }, 1500);
      } else {
        setError("Failed to save the settings.");
      }
    } catch (error) {
      console.error("Error during settings update:", error);
      setError("An error occurred while saving the settings.");
    } finally {
      setSaving(false);
    }
  };

  // Toggle component for cleaner code
  const ToggleSwitch = ({ checked, onChange, label }) => (
    <div className="flex items-center justify-between py-3 px-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-200">
      <span className="text-sm font-medium text-gray-700">{label}</span>
      <button
        type="button"
        onClick={onChange}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
          checked ? "bg-blue-600" : "bg-gray-300"
        }`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200 ${
            checked ? "translate-x-6" : "translate-x-1"
          }`}
        />
      </button>
    </div>
  );

  // Input field component
  const InputField = ({ id, label, type = "text", icon: Icon, required = false }) => (
    <div className="relative">
      <label
        htmlFor={id}
        className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2"
      >
        {Icon && <Icon className="w-4 h-4 text-blue-600" />}
        {label}
        {required && <span className="text-red-500">*</span>}
      </label>
      <input
        type={type}
        id={id}
        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-gray-400"
        value={formData[id]}
        onChange={handleInputChange}
        required={required}
      />
    </div>
  );

  // Card component
  const Card = ({ title, icon: Icon, children }) => (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-4 flex items-center gap-3">
        {Icon && <Icon className="w-5 h-5 text-white" />}
        <h2 className="text-lg font-semibold text-white">{title}</h2>
      </div>
      <div className="p-6 space-y-4">{children}</div>
    </div>
  );

  if (loading) {
    return (
      <div className="flex h-screen bg-gray-50">
        <div className="flex-shrink-0">
          <Slider />
        </div>
        <div className="flex-grow flex items-center justify-center">
          <div className="flex flex-col items-center gap-4">
            <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
            <p className="text-gray-600 font-medium">Loading settings...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen bg-gray-100">
      <div className="flex-shrink-0">
        <Slider />
      </div>

      <div className="flex-grow p-6 overflow-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
            <Settings className="w-8 h-8 text-blue-600" />
            Settings
          </h1>
          <p className="text-gray-500 mt-1">Manage your application configuration</p>
        </div>

        {/* Error Modal */}
        {isErrorModalOpen && (
          <ErrorModal message={error} onClose={() => setIsErrorModalOpen(false)} />
        )}

        {/* Success Modal */}
        {isSuccessVisible && (
          <SuccessModal message={successMessage} onClose={() => setIsSuccessVisible(false)} />
        )}

        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
            {/* Feature Settings Card */}
            <Card title="Feature Settings" icon={ToggleRight}>
              <ToggleSwitch
                checked={formData.btnSubCategory}
                onChange={() => handleToggle("btnSubCategory")}
                label="SubCategory"
              />
              <ToggleSwitch
                checked={formData.btnDelivery}
                onChange={() => handleToggle("btnDelivery")}
                label="Delivery"
              />
              <ToggleSwitch
                checked={formData.btnLocation}
                onChange={() => handleToggle("btnLocation")}
                label="Location"
              />
              <ToggleSwitch
                checked={formData.btnCoupon}
                onChange={() => handleToggle("btnCoupon")}
                label="Coupon"
              />
              <ToggleSwitch
                checked={formData.btnWallet}
                onChange={() => handleToggle("btnWallet")}
                label="Wallet"
              />
              <ToggleSwitch
                checked={formData.btnSubscription}
                onChange={() => handleToggle("btnSubscription")}
                label="Subscription"
              />
            </Card>

            {/* Payment Settings Card */}
            <Card title="Payment Settings" icon={DollarSign}>
              <ToggleSwitch
                checked={formData.btnRazorpay}
                onChange={() => handleToggle("btnRazorpay")}
                label="Razorpay"
              />
              <ToggleSwitch
                checked={formData.COD}
                onChange={() => handleToggle("COD")}
                label="Cash on Delivery (COD)"
              />
              <InputField
                id="txtPaymentId"
                label="Razorpay Key ID"
                icon={Key}
              />
              <InputField
                id="txtUrl"
                label="Minimum Order Amount"
                type="number"
                icon={DollarSign}
                required
              />
            </Card>

            {/* Contact Settings Card */}
            <Card title="Contact Settings" icon={MessageCircle}>
              <InputField
                id="WhatsAppUrl"
                label="WhatsApp URL"
                icon={LinkIcon}
              />
              <InputField
                id="OwnerMobileNo"
                label="Owner Mobile Number"
                icon={Phone}
              />
              <InputField
                id="Firebasetext"
                label="Firebase ID"
                icon={Key}
              />
            </Card>

            {/* Theme Settings Card */}
            <Card title="Theme Settings" icon={Palette}>
              <InputField id="basecolorCode" label="Base Color Code" />
              <InputField id="colorCode" label="Primary Color Code" />
              <InputField id="shadowcolorCode" label="Shadow Color Code" />
              <InputField id="whitecolorCode" label="White Color Code" />
              <InputField id="lightblackcolorCode" label="Light Black Color Code" />
            </Card>
          </div>

          {/* Submit Button */}
          <div className="mt-8 flex justify-end">
            <button
              type="submit"
              disabled={saving}
              className="flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-semibold rounded-lg shadow-lg hover:from-blue-700 hover:to-blue-800 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200 active:scale-95 disabled:opacity-70 disabled:cursor-not-allowed"
            >
              {saving ? (
                <>
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  Saving...
                </>
              ) : (
                <>
                  <Save className="w-5 h-5" />
                  Save Settings
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Setting;